<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wmPgjT/tc-custom/9781421415963.jpg?1705766069170" alt="This image is the cover for the book Constitutional Calculus"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Constitutional Calculus
      </h1>
      <p class="bookDescription body article font2">
        <b>How math can make a more stable democracy: “A breath of fresh air . . . a reaffirmation that mathematics should be used more often to make general public policy.” —<i>MAA Reviews</i></b><br/><br/> How should we count the population of the United States? What would happen if we replaced the electoral college with a direct popular vote? What are the consequences of allowing unlimited partisan gerrymandering of congressional districts? Can six-person juries yield verdicts consistent with the needs of justice? Is it racist to stop and frisk minorities at a higher rate than non-minorities? These and other questions have long been the subject of legal and political debate and are routinely decided by lawyers, politicians, judges, and voters, mostly through an appeal to common sense and tradition.<br/><br/> But mathematician Jeff Suzuki asserts that common sense is not so common, and traditions developed long ago in what was a mostly rural, mostly agricultural, mostly isolated nation of three million might not apply to a mostly urban, mostly industrial, mostly global nation of three hundred million. In <i>Constitutional Calculus</i>, Suzuki guides us through the U.S. Constitution and American history to show how mathematics reveals our flaws, finds the answers we need, and moves us closer to our ideals.<br/><br/> From the first presidential veto to the debate over mandatory drug testing, the NSA’s surveillance program, and the fate of death row inmates, Suzuki draws us into real-world debates and then reveals how math offers a superior compass for decision-making. Relying on iconic cases, including the convictions of the Scottsboro boys, League of United Latin American Citizens v. Perry, and Floyd v. City of New York, Suzuki shows that more math can lead to better justice, greater fairness, and a more stable democracy.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jeff Suzuki
      </h2>
      
      <p class="authorDescription body article">Jeff Suzuki is an associate professor of mathematics at Brooklyn College. He is the author of Mathematics in Historical Context and Constitutional Calculus: The Math of Justice and the Myth of Common Sense.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Johns Hopkins University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?63f4300c